import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// Ensure lang attribute is set on html element
if (!document.documentElement.lang) {
  document.documentElement.lang = 'en';
}

const rootEl = document.getElementById('root');
if (rootEl) {
  const root = ReactDOM.createRoot(rootEl);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
}
